import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
} from '@apollo/client'
import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { ErrorLink } from '@apollo/client/link/error'

const configUrl = process.env.REACT_APP_HTTP_BASEURL || 'stage.nikebuilder.com'
const host = window.location.host

let origin = ''
if (host.includes(configUrl)) {
  origin = window.location.origin
} else {
  origin = 'https://stage.nikebuilder.com'
}

export const baseURL = origin + '/'

const httpLink = new HttpLink({
  uri: `${baseURL}graphql`,
  credentials: 'same-origin',
})

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  let token = sessionStorage.getItem('token') || ''

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token,
    },
  }))

  return forward(operation)
})

const logoutLink = new ErrorLink(({ error }) => {
  if (CombinedGraphQLErrors.is(error)) {
    const graphQLError: any = error.errors[0]
    const errorCode = graphQLError?.extensions?.code || graphQLError?.code

    if (errorCode === 'UNAUTHENTICATED') {
      const href = window.location.origin

      sessionStorage.removeItem('user')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('filters')
      sessionStorage.removeItem('theme')

      window.location.href = href
    }
  }
})

export const client = new ApolloClient({
  link: ApolloLink.from([authMiddleware, logoutLink, httpLink]),
  cache: new InMemoryCache(),
})
